import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { ApiTypes, CroppingPatternModel } from "@agroyaar/sdk";
import { Spin } from "antd";
import { getFarmerId } from "@new-services/utils/getFarmerId";
import { useCroppingPattern } from "@new-services/services";
import CroppingPatternReportPage from "@/features/reports/presentation/components/cropping-pattern/components/CroppingPatternReportPage";

const CroppingPattern = () => {
  const { id } = useParams();
  const [croppingPattern, setCroppingPattern] =
    useState<CroppingPatternModel>();

  const mechanizationVariables: ApiTypes.CroppingPattern["RequestParams"]["getOne"] =
    useMemo(
      () => ({
        pathParams: {
          croppingPatternId: id!,
          farmerId: getFarmerId()!,
        },
      }),
      [id]
    );

  const croppingPatternQuery = useCroppingPattern(mechanizationVariables);

  useEffect(() => {
    if (croppingPatternQuery.data) {
      setCroppingPattern(croppingPatternQuery.data);
    }
  }, [croppingPatternQuery.data]);

  return (
    <div>
      {croppingPatternQuery.isLoading ||
      !croppingPatternQuery.data?.reports.length ? (
        <div>
          <Spin
            size="large"
            className="flex justify-center h-60 items-center !text-purple-950"
          />
          <p className="flex justify-center items-center">
            در حال آماده‌سازی گزارش
          </p>
          <span className="flex justify-center mt-10 text-sm">
            ممکن است پردازش اطلاعات شما دقایقی زمان ببرد، لطفا منتظر بمانید...
          </span>
        </div>
      ) : (
        <CroppingPatternReportPage
          isLoading={croppingPatternQuery.isLoading}
          croppingPattern={croppingPattern}
        />
      )}
    </div>
  );
};

export default CroppingPattern;
